import { useTranslation } from 'react-i18next';

import { ConfirmDialog } from '@/components/molecules/ConfirmDialog';
import { useDeleteLocation } from '@/domain/locations';

import type { ClientLocationProps } from '../Client';

interface DeleteLocationConfirmProps {
    onClose: () => void;
    isOpen: boolean;
    location: ClientLocationProps | null;
    refetch: () => void;
}

function DeleteLocationConfirm({ onClose, isOpen, location, refetch }: DeleteLocationConfirmProps) {
    const { t } = useTranslation();
    const deleteLocation = useDeleteLocation();

    const handleConfirm = async () => {
        if (!location) return;
        await deleteLocation.mutateAsync(location.id);
        refetch();
    };

    return (
        <ConfirmDialog
            isOpen={isOpen}
            onClose={onClose}
            title={t('internal.clientLocations.deleteTitle')}
            message={t('internal.clientLocations.confirmDeleteNamed', {
                name: location?.name ?? '',
            })}
            confirmLabel={t('common.actions.delete')}
            confirmDisabled={!location}
            onConfirm={handleConfirm}
        />
    );
}

export default DeleteLocationConfirm;
